import { useSelector } from 'react-redux'
import Popover from '../Popover'
import { getSpecification, getAdditionalInfo } from '../../utils/bike-schema'

const SpecificationPopover = () => {
  const { specification, bikeConfig, lang } = useSelector((state) => state)
  const baseModelId = bikeConfig.baseModelId

  let currentSpecification, name

  if (specification === 'additional-info') {
    currentSpecification = getAdditionalInfo(baseModelId, lang, bikeConfig)
    name = 'Additional'
  } else {
    let currentOption = ''
    bikeConfig.choices.forEach(({ componentId, optionId }) => {
      if (componentId === specification) {
        currentOption = optionId
      }
    })
    const specificationArray = getSpecification(
      baseModelId,
      specification,
      currentOption,
      lang
    )
    currentSpecification = specificationArray[0]
    name = specificationArray[1]
  }

  return (
    <Popover
      className="velorbis-customizer-option-list"
      alignTo={`.velorbis-customizer-component[data-component="${specification}"]`}
      maxWidth={'400px'}
    >
      <div className="velorbis-customizer-popover-header">
        {`${name} specification`}
      </div>
      <div className="velorbis-customizer-popover-body">
        {typeof currentSpecification !== 'string'
          ? currentSpecification.map((spec) => (
              <div
                className="velorbis-customizer-popover-body-additional-item"
                key={Math.random()}
              >
                {spec}
              </div>
            ))
          : currentSpecification}
      </div>
    </Popover>
  )
}

export default SpecificationPopover
